import React, { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import Routers from "./Routes";
import { setToken } from "./Utils/apiUtils"; // make sure folder is lowercase
import { useAppDispatch } from "./ReduxToolkit/Hooks";
import { logout } from "./ReduxToolkit/Reducers/Layout/AuthReducer";

const IDLE_TIMEOUT = 10 * 60 * 1000; // 15 minutes

const App = () => {
  // const dispatch = useAppDispatch();
  // useEffect(() => {
  // let idleTimer: NodeJS.Timeout;
  // const logoutUser = () => {
  //   setToken("");
  //   localStorage.removeItem("token");
  //   dispatch(logout());
  // };
  // const resetTimer = () => {
  //   if (idleTimer) clearTimeout(idleTimer);
  //   idleTimer = setTimeout(logoutUser, IDLE_TIMEOUT);
  // };
  // const activityEvents = ["mousemove", "keydown", "mousedown", "touchstart"];
  // activityEvents.forEach((event) =>
  //   window.addEventListener(event, resetTimer)
  // );
  // resetTimer();
  // return () => {
  //   if (idleTimer) clearTimeout(idleTimer);
  //   activityEvents.forEach((event) =>
  //     window.removeEventListener(event, resetTimer)
  //   );
  // };
  // }, []);

  return (
    <>
      <Routers />
      <ToastContainer />
    </>
  );
};

export default App;
